import { render, staticRenderFns } from "./ClasificacionPatenteModal.vue?vue&type=template&id=51b38d16&"
import script from "./ClasificacionPatenteModal.vue?vue&type=script&lang=ts&"
export * from "./ClasificacionPatenteModal.vue?vue&type=script&lang=ts&"
import style0 from "./ClasificacionPatenteModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports